import { useField, useFormikContext } from 'formik';
import * as React from 'react';
import { FormControl } from 'react-bootstrap';
import { Field, getFieldPrimitiveFromString, getFieldStringFromPrimitive } from 'gossamer-unified';
import { General } from '../index';

export interface FormFieldProps {
  className?: string;
  clearOnSelection?: boolean;
  editable: boolean;
  fullId: string;
  field: Field;
}

export const FormField = (props: FormFieldProps): React.JSX.Element => {
  const [field, meta, helper] = useField({ name: props.fullId });
  const { submitCount } = useFormikContext();
  // fields absent from initialValues are not marked touched by Formik on submit, so also show validity once a
  // submit has been attempted
  const showValidity = meta.touched || submitCount > 0;
  return (
    <>
      <General
        className={props.className}
        editable={props.editable}
        fieldId={props.fullId}
        field={props.field}
        handleChange={(newValue: string | null) =>
          helper.setValue(getFieldPrimitiveFromString(props.field.type, newValue || ''))
        }
        validity={showValidity ? !meta.error : undefined}
        value={getFieldStringFromPrimitive(props.field.type, field.value)}
      />
      {meta.error && showValidity &&<FormControl.Feedback type="invalid">{meta.error}</FormControl.Feedback>}
    </>
  );
};
